import Vue from 'vue'
import Router from 'vue-router'
import MoorparkGrove from '@/components/MoorparkGrove'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MoorparkGrove',
      component: MoorparkGrove
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js